import CopyModal from 'features/MenuBook/components/CopyModal';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
function DuplicationDisplayModalDemo() {
  const [show, setShow] = useState(false);
  function handleClose() {
    setShow(false);
  }
  function handleShowModal() {
    setShow(true);
  }
  const menu_book_id = '1';
  const menu_book_name = 'menu_book_1';
  const course_id = '';
  const course_name = '';
  const genre_id = '1';
  const genre_name = 'genre 1';
  const sub_genre_id = '1';
  const sub_genre_name = 'subgenre';
  const menu_id = '1';
  const menu_name = 'menu 1';

  function onSaveSuccess(status: boolean) {
    alert(status);
  }
  return (
    <>
      <Button onClick={handleShowModal}>DuplicationDisplayModal </Button>
      <CopyModal
        menuBookId={menu_book_id}
        menuBookName={menu_book_name}
        courseId={course_id}
        courseName={course_name}
        genreId={genre_id}
        genreName={genre_name}
        subGenreId={sub_genre_id}
        subGenreName={sub_genre_name}
        menuId={menu_id}
        menuName={menu_name}
        onSaveSuccess={onSaveSuccess}
        onClose={handleClose}
        show={show}
      />
    </>
  );
}
export default DuplicationDisplayModalDemo;
